import { DOM } from "@siteimprove/alfa-aria";
import { Cache } from "@siteimprove/alfa-cache";
import { Element, Namespace, Node, Query, } from "@siteimprove/alfa-dom";
import { None, Option } from "@siteimprove/alfa-option";
import { Predicate } from "@siteimprove/alfa-predicate";
import { Style } from "@siteimprove/alfa-style";
import { Question } from "../act/question.js";
const { isPerceivableForAll } = DOM;
const { isElement, hasName, hasNamespace, hasAttribute } = Element;
const { and } = Predicate;
const { isRendered } = Style;
const { getElementDescendants } = Query;
const cache = Cache.empty();
export function audio(document, device) {
    return cache.get(document, Cache.empty).get(device, () => getElementDescendants(document, Node.fullTree)
        .filter(
    // Non-rendered <audio> are not playing
    and(hasNamespace(Namespace.HTML), hasName("audio"), isRendered(device)))
        .map((element) => Question.of("is-audio-streaming", element).map((isStreaming) => isStreaming
        ? None
        : Question.of("is-playing", element)
            .answerIf(hasAttribute("autoplay"), true)
            .map((isPlaying) => isPlaying
            ? Option.of(element)
            : Question.of("play-button", element)
                .answerIf(hasAttribute("controls"), Option.of(element))
                .map((playButton) => playButton.some(and(isElement, isPerceivableForAll(device)))
                ? Option.of(element)
                : None)))));
}
//# sourceMappingURL=audio.js.map